import React from "react";
import styles from './InstanceDetails.module.scss'

function InstanceDetails({deployment}) {

    const {request_dump} = deployment;

    const details = [
        {title: 'Servers count', prop: request_dump.custom.servers_count},
        {title: 'Provider', prop: request_dump.provider},
        {title: 'Image', prop: request_dump.os},
        {title: 'Region', prop: request_dump.region},
        {title: 'Server', prop: request_dump.server},
        {title: 'Disk type', prop: request_dump.disk_type},
    ]

    return (
        <div className={styles.details}>
            {
                details.map((detail, index) => (
                    <div className={styles.detail} key={index}>
                        <p className={styles.detail__name}>{detail.title}:</p>
                        <p className={styles.detail__value}>{detail.prop || '-'}</p>
                    </div>
                ))
            }
            {/*<div>Servers count: {deployment.request_dump.custom.servers_count}</div>*/}
            {/*<div>Provider: {deployment.request_dump.provider}</div>*/}
            {/*<div>Image: {deployment.request_dump.os}</div>*/}
            {/*<div>Region: {deployment.request_dump.region}</div>*/}
            {/*<div>Server: {deployment.request_dump.server}</div>*/}
            {/*/!*<div>Zone: {deployment.request_dump.zone}</div>*!/*/}
            {/*/!*<div>Selected plan: {deployment.request_dump.selected_plan}</div>*!/*/}
            {/*<div>Disk type: {deployment.request_dump.disk_type}</div>*/}
        </div>
    )
}

export default InstanceDetails